<div class="produto-incluso">
    <h2 class="section-title-h2 wow fadeIn" data-wow-delay="0.5s">
        Confira o que está<br>
        incluso ou não no seu passeio
    </h2>
    <div class="content">
        <div class="header">
            <div class="header-item wow slideInLeft" data-wow-delay="0.5s">
                <img width="90px" class="compare-section_header_item_icon-box_img" src="/images/template/icons/incluso.svg" alt="Incluso" />
                <h3>INCLUSO</h3>   
            </div>
            <div class="vs wow slideInDown" data-wow-delay="0.5s">
                OU
            </div>
            <div class="header-item wow slideInRight" data-wow-delay="0.5s">
                <img width="90px" src="/images/template/icons/nao-incluso.svg" class="compare-section_header_item_icon-box_img" alt="Não Incluso" />
                <h3 class="yellow">NÂO INCLUSO</h3>   
            </div>    
        </div> 
        <div class="list">
            <div class="list-coluna">
                <div class="list-coluna-item wow slideInUp" data-wow-delay="0.5s" *ngFor="let i of incluso">
                    <span>{{i.descricao}}</span>
                </div>    
            </div>
            <div class="list-divisor">
                <span></span>
            </div>
            <div class="list-coluna">  
                <div class="list-coluna-item right wow slideInUp" data-wow-delay="0.5s" *ngFor="let i of naoIncluso">
                    <span>{{i.descricao}}</span>
                </div>
            </div>
        </div>    
    </div> 
</div>   
    
    
    
  